import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import AuthorizationRedirect from './AuthorizationRedirect';
import { connect } from 'react-redux';
import {
	revokeAccessToken,
	ZOOM_REVOKE_ACCESS_TOKEN_REQUEST, ZOOM_REVOKE_ACCESS_TOKEN_SUCCESS, ZOOM_REVOKE_ACCESS_TOKEN_FAILURE
} from './actions';
import ReduxBlockUi from 'react-block-ui/redux';
import { withTranslation } from 'react-i18next';

class ZoomForm extends Component {
	constructor(props) {
		super(props);
		this.handleConnect = this.handleConnect.bind(this);
		this.handleDisconnect = this.handleDisconnect.bind(this);

		this.state = { redirect: false };
	}

	handleConnect() {
		this.redirect(false);
	}

	redirect() {
		this.setState({
			redirect: true
		});
	}

	handleDisconnect() {
		const { centerId, revokeAccessToken, onConfigurationUpdated } = this.props;
		revokeAccessToken({ centerId }, onConfigurationUpdated);
	}

	render() {
		const { t, connected, franchisor, franchiseeId, centerId } = this.props;

		return (
			<div>
				<FormGroup>
					<ControlLabel>{t('Zoom_Description')}</ControlLabel>
					<FormControl.Static>
						<ReduxBlockUi
							block={[ZOOM_REVOKE_ACCESS_TOKEN_REQUEST]}
							unblock={[ZOOM_REVOKE_ACCESS_TOKEN_SUCCESS, ZOOM_REVOKE_ACCESS_TOKEN_FAILURE]}>
							{!connected && <Button bsStyle='primary' onClick={this.handleConnect}>{t('Zoom_Connect')}</Button>}
							{connected && <Button bsStyle='primary' onClick={this.handleDisconnect}>{t('Zoom_Disconnect')}</Button>}
							{this.state.redirect && <AuthorizationRedirect franchisor={franchisor} franchiseeId={franchiseeId} centerId={centerId} />}
						</ReduxBlockUi>
					</FormControl.Static>
				</FormGroup>
			</div>
		);
	}
}

export default connect(null, {
	revokeAccessToken
})(withTranslation()(ZoomForm));